<template>
  <sign-page
    title-text="软件"
    :request="request"
    :column-list="columnList"
    :form-parms-add="formParmsAdd"
    :table-actions-width="100"
    :form-parms-update="formParmsUpdate"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  softRequest as request
} from '@/api'

export default {
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '名称',
          key: 'name',
          check: {
            required: true
          }
        },
        {
          type: 'textarea',
          label: '版本',
          key: 'version'
        },
        {
          type: 'select',
          label: '安装类型',
          key: 'installTypeId',
          selectDatas: this.$store.getters.installTypeList
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = []
        this.formParmsAdd.filter(v => v.key !== 'installTypeId').forEach((item) => {
          data.push({
            field: item.key,
            title: item.label
          })
        })
        return data
      }
    }
  },
  created () {
    this.$store.dispatch('loadInstallTypeList')
  },
  methods: {
  },
  data () {
    return {
      request: request
    }
  }
}
</script>
